import { useAuth0 } from "@auth0/auth0-react";
import {
  markItemNotificationsRead,
  searchMembers,
  searchUsers,
} from "../../../../Api";
import MentionTextarea, { MentionSuggestion } from "../../../MentionTextarea";
import { useMentions } from "../../../MentionTextarea/MentionContext";
import { useContext, useEffect, useRef, useState } from "react";
import IdeaContext from "../../IdeaContext";
import {
  Box,
  Button,
  Group,
  ScrollArea,
  Text,
} from "@mantine/core";
import { IconSend, IconX } from "@tabler/icons";
import { CommentsNiv } from "./CommentsNiv";
import useComments from "../../../../hooks/useComments";
import DiscoveryContext from "../../../Discovery/DiscoveryContext";
import SingleCustomerContext from "../../../Customer360/Customer-Context/SingleCustomerContext";
import ActivityFeed from "../../../ActivityFeed";
import { useIdeaPage } from "../../../../hooks/ideaPage";

const AiCommentsSection = ({
  item : propChosenEvidence,
  setOpened,
  componentType,
  commentId,
  //   chosenEvidence: propChosenEvidence,
  getUnreadNotificationsCountByRequest: propGetUnreadNotificationsCountByRequest
}: {
  item: any;
  setOpened: any;
  componentType: string;
  commentId?: string | null;
//   chosenEvidence?: any;
  getUnreadNotificationsCountByRequest?: (requestId: string) => number;
}) => {
  const contextData = useIdeaPage();
  const { getUnreadNotificationsCountByRequest: contextGetUnreadNotificationsCountByRequest } = contextData;
  // Use props if provided, otherwise use context
  const finalChosenEvidence = propChosenEvidence;
  const finalGetUnreadNotificationsCountByRequest = propGetUnreadNotificationsCountByRequest || contextGetUnreadNotificationsCountByRequest;
  const { addComment, loading, fetchComments, fetchActivityLogs, ...rest } = useComments({
    evidenceId: finalChosenEvidence?._id,
  });
  const { setSuggestions, setLoading: setSuggestionsLoading } = useMentions();
  const [commentValue, setCommentValue] = useState("");

  const auth0 = useAuth0();
  const viewport = useRef<HTMLDivElement>(null);
  const scrollToCommentsBottom = () =>
    viewport?.current?.scrollTo({
      top: viewport.current.scrollHeight,
      behavior: "smooth",
    });

  const closePanel = () => {
    setOpened(false);
  };

  useEffect(() => {
    if(finalChosenEvidence?._id) {
      fetchActivityLogs();
    }
  }, [finalChosenEvidence?._id]);

  const searchUser = ({
    query,
  }: {
    query: string;
  }): Promise<MentionSuggestion[]> => {
    /* setSuggestionsLoading(true); */

    return new Promise<MentionSuggestion[]>((resolve, reject) => {
   
      Promise.all([searchUsers(query, auth0), searchMembers(query, auth0)])
        .then(([users, members]) => {
          
          const userSuggestions: MentionSuggestion[] =
            users?.map((user: any) => ({
              id: user?._id,
              email: user?.email,
              name: user?.name,
              picture: user?.picture,
            })) ?? [];

          const memberSuggestions: MentionSuggestion[] =
            members
              ?.filter((member: any) => member.name)
              .map((member: any) => ({
                id: member?._id,
                email: member?.email,
                name: member?.name,
                picture: member?.picture,
              })) ?? [];

          const combinedSuggestions = [
            ...userSuggestions,
            ...memberSuggestions,
          ];
          const emailToUserMap = new Map<string, MentionSuggestion>();

          combinedSuggestions.forEach((suggestion) => {
            if (
              !emailToUserMap.has(suggestion.email) ||
              memberSuggestions.find(
                (member) => member.email === suggestion.email
              )
            ) {
              emailToUserMap.set(suggestion.email, suggestion);
            }
          });

          const uniqueSuggestions = Array.from(emailToUserMap.values());
        
          setSuggestions(uniqueSuggestions);
          resolve(uniqueSuggestions);
        })
        .catch((error) => {
          console.error("Error searching users and members:", error);
          reject(error);
        })
        .finally(() => setSuggestionsLoading(false));
    });
  };

  const markItemNotificationsReadFunc = async () => {
    await markItemNotificationsRead(propChosenEvidence?._id, auth0).then((res) => {
      console.log({ res });
    });
  };
  useEffect(() => {
    if (finalGetUnreadNotificationsCountByRequest(propChosenEvidence?._id) > 0)
      markItemNotificationsReadFunc();
    /* scrollToBottom(); */
  }, [finalChosenEvidence]);

  // Refs for preventing closing the window
  const editorBoxRef = useRef<HTMLDivElement>(null);
  const suggestionBoxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const commentsSection = document.getElementById('comments-section');
      // Check if the clicked element is inside the comments section
      let isInside = false;
      let currentElement = target;
      
      while (currentElement && currentElement !== document.body) {
        if (currentElement.id === 'comments-section') {
          isInside = true;
          break;
        }
        currentElement = currentElement.parentElement as Element;
      }
      const isMenuClick = target.closest('#comments-menu-dropdown') ||
                         target.closest('[id="comments-menu-dropdown"]');
      
      // Check if the click is on a mention suggestion (tippy popup)
      const isMentionSuggestion = target.closest('[data-tippy-root]') ||
                                 target.closest('.tippy-box') ||
                                 target.closest('.tippy-content') ||
                                 target.closest('.items') ||
                                 target.classList.contains('item') ||
                                 target.closest('.item');
      
      // Only close if click is outside the comments section AND not on the specific menu AND not on mention suggestions
      if (commentsSection && !isInside && !isMenuClick && !isMentionSuggestion) {
        closePanel();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchComments();
  }, []);

  return (
    <Box 
     
      id="comments-section" 
      h="calc(100vh - 173px)" 
      w="496px"
      sx={{ display: "flex", flexDirection: "column" }}
    >
      {/* Comments header */}
      <Group
        py={14}
        px={35}
        position="apart"
        sx={{ borderBottom: "1px solid #D8D8DB", flexShrink: 0 }}
        bg="#FDFEFF"
      >
        <Text color="#212529" fz={20} fw={600}>
          Activity
        </Text>
        <Group
          align="center"
          sx={{ cursor: "pointer" }}
          onClick={() => setOpened(false)}
        >
          <IconX size={16} color="#5C5CEB" />
          <Text ml="3px" color="#5C5CEB" fz={12}>
            Close
          </Text>
        </Group>
      </Group>

      {/* Comments Body */}
      {/* <ScrollArea
        viewportRef={viewport}
        style={{ width: "100%", height: "calc(100vh - 291px)" }}
      >
        <CommentsNiv
          addComment={addComment}
          loading={loading}
          fetchComments={fetchComments}
          {...rest}
        />
      </ScrollArea> */}
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <ActivityFeed 
          commentId={commentId} 
          {...rest}
        />
      </Box>

      {/* Add a comment */}
      <Box
        sx={{
          background: "#F5F6FE",
          borderTop: "1px solid #E5E7EB",
          padding: 10,
          flexShrink: 0,
        }}
      >
        <MentionTextarea<MentionSuggestion>
          placeholder="Write your message"
          getMentions={searchUser}
          commentValue={commentValue}
          setCommentValue={setCommentValue}
          editable
          clearOnRightSectionClick
          debounceWait={1000}
          sx={{
            background: "#fff",
            border: "1px solid #D8D8DB",
            borderRadius: 8,
            fontSize: 12,
            maxHeight: "60px",
            overflow: "auto",
          }}
          editorBoxRef={editorBoxRef}
          suggestionBoxRef={suggestionBoxRef}
        />
        <Group position="right" mt={8}>
          <Button
            compact
            onClick={async () => {
              await addComment(commentValue)
                .then(() => setCommentValue(""))
              
              scrollToCommentsBottom();
            }}
            variant="filled"
            color="blue"
            radius="md"
            loading={loading.add}
            disabled={commentValue.trim() === '<p></p>' || commentValue.trim() === ''}
            leftIcon={<IconSend size={16} />}
          >
            Send
          </Button>
        </Group>
      </Box>
    </Box>
  );
};
export default AiCommentsSection;
